import Mexp from 'math-expression-evaluator'
const mexp = new Mexp()

export const evaluateMathExpr = (formula: string): number => {
  try {
    const lexed = mexp.lex(formula, [])
    const postfixed = mexp.toPostfix(lexed)
    const result = mexp.postfixEval(postfixed, {})
    return Number(result.toFixed(2))
  } catch (err) {
    return 0
  }
}
